import classNames from 'classnames';
import type { ReactNode } from 'react';
import type {
  ButtonAccent,
  ButtonSize,
  ButtonVariant,
  IconPosition,
} from './Button';

export const getButtonClassNames = (
  children: ReactNode,
  variant: ButtonVariant,
  className?: string,
  accent?: ButtonAccent,
  size?: ButtonSize,
  inversed?: boolean,
  iconPosition?: IconPosition,
): string =>
  classNames(
    className,
    'button',
    `button--${variant}`,
    accent ? `button--${accent}` : 'button--positive',
    size ? `button--${size}` : 'button--xs',
    inversed && 'button--inversed',
    !children && 'button--square',
    iconPosition ? `button--${iconPosition}` : 'button--left',
  );
